const url =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_API_URL
    : process.env.REACT_APP_DEV_API_URL;

const api_key =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_APIKEY
    : process.env.REACT_APP_DEV_APIKEY;

const config = {
  headers: {
    AUTHORIZATION: process.env.REACT_APP_AUTHORIZATION,
    APIKEY: api_key,
    USERNAME: process.env.REACT_APP_USERNAME,
    ACCEPT: "application/json, text/plain, */*",
    "Content-Type": "application/json"
  }
};
function Object_assign(target, ...sources) {
  sources.forEach(source => {
    Object.keys(source).forEach(key => {
      let s_val;
      const t_val = target[key];
      if (
        key === "transfers" &&
        source[key][0]["id"] !== target[key][0]["id"]
      ) {
        s_val = [{}, source[key][0]];
      } else {
        s_val = source[key];
      }

      target[key] =
        t_val && s_val && typeof t_val === "object" && typeof s_val === "object"
          ? Object_assign(t_val, s_val)
          : s_val;
    });
  });

  return target;
}
const SimulateServer = values => {
  return new Promise((resolve, reject) => {
    setTimeout(
      resolve({
        values: JSON.parse(`{
      "status_code": 200,
      "status_description": "OK",
      "notifications": [],
      ${values.slice(1, -1)},
    "user": {
        "username": "${localStorage.getItem("mainEmail")}",
        "allowGuest": "${localStorage.getItem("guest")}"
    }
}`)
      }),
      3000
    );
  });
};

function setLocals(jsonResult) {
  function checkChildren() {
    if (jsonResult.basket.transfers[0].children.length > 0) {
      localStorage.setItem(
        "childrenOut",
        JSON.stringify(jsonResult.basket.transfers[0].children)
      );
    } else {
      localStorage.setItem("childrenOut", "{}");
    }
    if (jsonResult.basket.transfers[1]) {
      if (jsonResult.basket.transfers[1].children.length > 0) {
        localStorage.setItem(
          "childrenIn",
          JSON.stringify(jsonResult.basket.transfers[1].children)
        );
      } else {
        localStorage.setItem("childrenIn", "{}");
      }
    }
  }
  localStorage.setItem("basketID",jsonResult.basket.id)
  localStorage.setItem(
    "cart",
    `{"basket":${JSON.stringify(jsonResult.basket)}}`
  );
  localStorage.setItem("outID", jsonResult.basket.transfers[0].id);
  if (jsonResult.basket.transfers[1]) {
    localStorage.setItem("inID", jsonResult.basket.transfers[1].id);
  } else {
    localStorage.removeItem("inID");
    localStorage.setItem("childrenIn", "{}");
  }
  checkChildren();
}
function saveToLS(cartUpdate) {
  const cart = localStorage.getItem("cart");
  const update = JSON.stringify(
    Object_assign(Object.create(JSON.parse(cart)), cartUpdate)
  );
  localStorage.setItem("cart", update);
  return update;
}
function getBabySeat(children) {
  let seat;

  switch (children.code) {
    case "BABY":
      seat = "Baby";
      break;
    case "NONE":
      seat = "Not Required";
      break;
    case "BOOS":
      seat = "Booster";
      break;
    default:
      break;
  }
  return seat;
}
function setChildrenOptions(transfers) {
  function replaceChild(des) {
    let childrenLoop = JSON.parse(localStorage.getItem(`children${des}`));
    for (const key in childrenLoop) {
      const child = childrenLoop[key];
      if (child.id === transfers.basket.transfers[0].children[0].id) {
        if (transfers.basket.transfers[0].children[0].seatType) {
          transfers.basket.transfers[0].children[0].seatType.description = getBabySeat(
            transfers.basket.transfers[0].children[0].seatType
          );
        }
        childrenLoop[key] = Object_assign(
          child,
          transfers.basket.transfers[0].children[0]
        );
        const childrenInTemp = JSON.parse(localStorage.getItem(`childrenIn`));
        if (des === "Out" && childrenInTemp.length > 0) {
          if (childrenInTemp[key]) {
            childrenInTemp[key]["age"] = childrenLoop[key]["age"];
            childrenInTemp[key]["seatType"] = childrenLoop[key]["seatType"];
          }
          localStorage.setItem(`childrenIn`, JSON.stringify(childrenInTemp));
        }
      }
    }
    localStorage.setItem(`children${des}`, JSON.stringify(childrenLoop));
    return childrenLoop;
  }
  const childrenOut = replaceChild("Out");
  const childrenIn = replaceChild("In");
  return { childrenOut, childrenIn };
}
function cloneToReturn(transfers, extra = null) {
  if (
    extra !== "STP3" ||
    (extra === "STP3" && !transfers["basket"]["transfers"][0]["notes"])
  ) {
    if (transfers["basket"]["transfers"][0]["toAccommodation"]) {
      transfers["basket"]["transfers"][1] = {};
      transfers["basket"]["transfers"][1]["fromAccommodation"] = {
        ...transfers["basket"]["transfers"][0]["toAccommodation"]
      };
    } else {
      transfers["basket"]["transfers"][1] = {
        ...transfers["basket"]["transfers"][0]
      };
    }
    if (
      transfers["basket"]["transfers"][0]["notes"] &&
      transfers["basket"]["transfers"][0]["id"] === localStorage.getItem("inID")
    ) {
      transfers["basket"]["transfers"][1] = {};
      transfers["basket"]["transfers"][1]["notes"] =
        transfers["basket"]["transfers"][0]["notes"];
      transfers["basket"]["transfers"][1]["id"] = localStorage.getItem("inID");
      transfers["basket"]["transfers"][0]["id"] = localStorage.getItem("outID");
    }

    transfers["basket"]["transfers"][1]["id"] = localStorage.getItem("inID");
  }
  return transfers;
}
async function save(params) {
  config.method = "POST";
  config.body = JSON.stringify(params);
  const res = await fetch(url + "basket/updateBasket/", config);
  if (res.status !== 200) {
    const error = new Error(res.statusText);
    error.status = res.status;
    return Promise.reject(error);
  }
  return res.json();
}
async function postDataToLocal(transfers, extra = "", local = false) {
  let outJourney = false;
  if (
    localStorage.getItem("outID") === transfers["basket"]["transfers"][0]["id"]
  ) {
    outJourney = true;
  }
  if (transfers.basket.transfers[0].children) {
    if (transfers.basket.transfers[0].children.length > 0) {
      const childrenResult = setChildrenOptions(transfers);
      transfers.basket.transfers[0] = {
        id: localStorage.getItem("outID"),
        children: childrenResult.childrenOut
      };
      if (localStorage.getItem("inID")) {
        transfers.basket.transfers[1] = {
          id: localStorage.getItem("inID"),
          children: childrenResult.childrenIn
        };
      }
    }
  }
  if (
    (transfers.basket.transfers[0].notes && localStorage.getItem("inID")) ||
    (outJourney &&
      localStorage.getItem("inID") &&
      !transfers.basket.transfers[0].children &&
      !transfers.basket.transfers[0].flightNumber)
  ) {
    cloneToReturn(transfers, extra);
  }

  const newCart = saveToLS(transfers);
  if (
    typeof transfers["basket"]["transfers"][0]["email"] !== "undefined" &&
    outJourney
  ) {
    localStorage.setItem(
      "mainEmail",
      transfers["basket"]["transfers"][0]["email"]
    );
  }
  if (
    typeof transfers["basket"]["transfers"][0]["mobile"] !== "undefined" &&
    outJourney &&
    transfers["basket"]["transfers"][0]["mobile"] !== "+"
  ) {
    local = true;
    postDataToServer(transfers, "savingStep1", local);
  }

  const jsonResult = await SimulateServer(newCart);
  return jsonResult.values;
}
async function postDataToServer(transfers, extra = "", local = false) {
  let jsonResult;
  let checkPrice = false;
  if (local) {
    const cart = JSON.parse(localStorage.getItem("cart"));
    transfers = {
      basket: {
        id: cart["basket"]["id"],
        guid: cart["basket"]["guid"],
        currency: cart["basket"]["currency"],
        transfers: cart["basket"]["transfers"]
      }
    };
  }
  if (
    transfers["basket"]["transfers"] &&
    (transfers["basket"]["transfers"][0]["numberOfChildren"] ||
      transfers["basket"]["transfers"][0]["adults"] ||
      transfers["basket"]["transfers"][0]["numberOfHoldItems"] ||
      transfers["basket"]["transfers"][0]["numberOfBikes"] ||
      transfers["basket"]["transfers"][0]["numberOfSkis"] ||
      transfers["basket"]["transfers"][0]["transferType"]) &&
    extra !== "savingStep1"
  ) {
    checkPrice = true;
    const cart = JSON.parse(localStorage.getItem("cart"));

    if (localStorage.getItem("inID")) {
      const isNumberOfChildren =
        "numberOfChildren" in transfers["basket"]["transfers"][0];
      const isAdult = "adults" in transfers["basket"]["transfers"][0];
      const transferLength = Object.keys(transfers["basket"]["transfers"][0])
        .length;
      if (transferLength <= 2 && (isNumberOfChildren || isAdult)) {
        if (!transfers["basket"]["transfers"][1]) {
          transfers["basket"]["transfers"][1] = {};
        }
        transfers["basket"]["transfers"][1]["id"] = localStorage.getItem(
          "inID"
        );
        transfers["basket"]["transfers"][1][
          isNumberOfChildren ? "numberOfChildren" : "adults"
        ] =
          transfers["basket"]["transfers"][0][
            isNumberOfChildren ? "numberOfChildren" : "adults"
          ];
      }
    }

    const localTransfers = {
      basket: {
        id: cart["basket"]["id"],
        guid: cart["basket"]["guid"],
        currency: cart["basket"]["currency"],
        transfers: cart["basket"]["transfers"]
      }
    };
    const localUpdate = await save(localTransfers);
    localStorage.setItem(
      "cart",
      `{"basket":${JSON.stringify(localUpdate.basket)}}`
    );
  }
  jsonResult = await save(transfers);
  switch (extra) {
    case "currency":
      localStorage.setItem(
        "cart",
        `{"basket":${JSON.stringify(jsonResult.basket)}}`
      );
      break;
    case "children":
      setLocals(jsonResult);
      break;
    case "savingStep1":
      const cart = JSON.parse(localStorage.getItem("cart"));
      jsonResult.basket.transfers[0].flightNumber =
        cart.basket.transfers[0].flightNumber;
      jsonResult.basket.transfers[0].fromAccommodation =
        cart.basket.transfers[0].fromAccommodation;
      jsonResult.basket.transfers[0].toAccommodation =
        cart.basket.transfers[0].toAccommodation;
      break;
    default:
      break;
  }
  if (checkPrice) {
    saveToLS(jsonResult);
    setLocals(jsonResult);
  }
  localStorage.setItem("guest",jsonResult.user.allowGuest);
    return jsonResult;
}
export default {
  basket: {
    fetchData: async (id: string, first = false) => {
      let jsonResult;
      if(id.length !== 32){
        first = false;
        window.location.replace('/quote/'+localStorage.getItem("guid"));
      }
      if (first) {
        localStorage.setItem("guid", id);
        config.method = "GET";
        delete config.body;
        const res = await fetch(url + "basket/getBasket/guid/" + id, config);
        if (res.status !== 200) {
          const error = new Error(res.statusText);
          error.status = res.status;
          return Promise.reject(error);
        }
        jsonResult = await res.json();
        setLocals(jsonResult);
      } else {
        const cart = localStorage.getItem("cart");
        jsonResult = await SimulateServer(cart);
      }
            return jsonResult;
    },
    postData: async (transfers, final = false, extra = "", local = false) => {
      if (final) {
        return postDataToServer(transfers, extra, local);
      } else {
        return postDataToLocal(transfers, extra, local);
      }
    },
    changePoints: async (id: string) => {
      config.method = "GET";
      delete config.body;
      const res = await fetch(
        url + "basket/changePoints/basketId/" + id,
        config
      );
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    },
    proceedStep: async (id: string, step: string) => {
      config.method = "GET";
      delete config.body;
      const res = await fetch(
        url + "basket/proceed/step/" + step + "/basketId/" + id,
        config
      );
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      localStorage.setItem("converted", jsonResult.basket.bookingId !== 0 ? true : false);
      return jsonResult;
    },
    validatePayment: async data => {
      config.method = "POST";
      config.body = JSON.stringify(data);

      const res = await fetch(url + "basket/validatePayment/", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }

      const jsonResult = await res.json();
      return jsonResult;
    },
    makePayment: async data => {
      config.method = "POST";
      config.body = JSON.stringify(data);
      const res = await fetch(url + "basket/makePayment/", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    },
    recordPayment: async data => {
      config.method = "POST";
      config.body = JSON.stringify(data);

      const res = await fetch(url + "basket/recordPayment/", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }

      const jsonResult = await res.json();
      return jsonResult;
    }
  },
  auth: {
    login: async login => {
      config.method = "POST";
      config.body = JSON.stringify(login);

      const res = await fetch(url + "basket/login", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }

      const jsonResult = await res.json();
      return jsonResult;
    },
    forgot: async user => {
      config.method = "POST";
      config.body = JSON.stringify(user);

      const res = await fetch(url + "user/remind", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }

      const jsonResult = await res.json();
      return jsonResult;
    },
    reset: async user => {
      config.method = "POST";
      config.body = JSON.stringify(user);

      const res = await fetch(url + "user/reset", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }

      const jsonResult = await res.json();
      return jsonResult;
    },
    update: async user => {
      config.method = "POST";
      config.body = JSON.stringify(user);

      const res = await fetch(url + "user/update", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }

      const jsonResult = await res.json();
      return jsonResult;
    }
  },
  paypal: {
    getVersion: async () => {
      config.method = "POST";
      delete config.body;
      const res = await fetch(url + "paypal2/version", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        error.status = res.status;
        return Promise.reject(error);
      }
      return res.json();
    }
  },
  info: {
    getHelp: async () => {
      config.method = "GET";
      delete config.body;

      const res = await fetch(url + "lookup/getHelpMessages", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    },
    getSeatTypes: async () => {
      config.method = "GET";
      delete config.body;

      const res = await fetch(url + "lookup/seatTypes", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    },
    GetChildAges: async () => {
      config.method = "GET";
      delete config.body;

      const res = await fetch(url + "lookup/getChildAges", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    },
    getPaymentCardTypes: async () => {
      config.method = "GET";
      delete config.body;

      const res = await fetch(url + "lookup/paymentCardTypes", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    },
    getPaymentCountries: async () => {
      config.method = "GET";
      delete config.body;

      const res = await fetch(url + "lookup/paymentCountries", config);
      if (res.status !== 200) {
        const error = new Error(res.statusText);
        //$FlowFixMe
        error.status = res.status;
        return Promise.reject(error);
      }
      const jsonResult = await res.json();
      return jsonResult;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api.js